export const IndustryOptions = [
  {value: 'Art and Culture', label: 'Art and Culture'},
  {value: 'Automotive', label: 'Automotive'},
  {value: 'Beauty', label: 'Beauty'},
  {value: 'Beauty&Fitness', label: 'Beauty&Fitness'},
  {value: 'Catering', label: 'Catering'},
  {value: 'Cleaning Services', label: 'Cleaning Services'},
  {value: 'Construction', label: 'Construction'},
  {value: 'Counseling and Mental Health', label: 'Counseling and Mental Health'},
  {value: 'Customer Support Services', label: 'Customer Support Services'},
  {value: 'Ecommerce', label: 'Ecommerce'},
  {value: 'Education', label: 'Education'},
  {value: 'Emergency Services', label: 'Emergency Services'},
  {value: 'Entertainment', label: 'Entertainment'},
  {value: 'Environmental Services', label: 'Environmental Services'},
  {value: 'Event Management', label: 'Event Management'},
  {value: 'Fashion', label: 'Fashion'},
  {value: 'Finance', label: 'Finance'},
  {value: 'Fitness and Wellness', label: 'Fitness and Wellness'},
  {value: 'Government', label: 'Government'},
  {value: 'Healthcare', label: 'Healthcare'},
  {value: 'Home Improvement', label: 'Home Improvement'},
  {value: 'Hospitality', label: 'Hospitality'},
  {value: 'Human Resources', label: 'Human Resources'},
  {value: 'Import and Export', label: 'Import and Export'},
  {value: 'Insurance', label: 'Insurance'},
  {value: 'IT', label: 'IT'},
  {value: 'IT Services', label: 'IT Services'},
  {value: 'Legal Services', label: 'Legal Services'},
  {value: 'Logistics and Transportation', label: 'Logistics and Transportation'},
  {value: 'Manufacturing', label: 'Manufacturing'},
  {value: 'Marketing', label: 'Marketing'},
  {value: 'Marketing & Advertising', label: 'Marketing & Advertising'},
  {value: 'Non Profit', label: 'Non Profit'},
  {value: 'Non-Profit', label: 'Non-Profit'},
  {value: 'Pharmaceuticals', label: 'Pharmaceuticals'},
  {value: 'Politics', label: 'Politics'},
  {value: 'Real Estate', label: 'Real Estate'},
  {value: 'Recruitment', label: 'Recruitment'},
  {value: 'Recruitment and Staffing', label: 'Recruitment and Staffing'},
  {value: 'Religious Institution', label: 'Religious Institution'},
  {value: 'Restaurants', label: 'Restaurants'},
  {value: 'Retail', label: 'Retail'},
  {value: 'Software', label: 'Software'},
  {value: 'Sports and Recreation', label: 'Sports and Recreation'},
  {value: 'Telecommunications', label: 'Telecommunications'},
  {value: 'Tradesperson', label: 'Tradesperson'},
  {value: 'Travel', label: 'Travel'},
  {value: 'Travel & Tourism', label: 'Travel & Tourism'},
  {value: 'Venue', label: 'Venue'},
  {value: 'Veterinary Services', label: 'Veterinary Services'},
  {value: 'Wholesale Trade', label: 'Wholesale Trade'}
]

export const AccountTypeOptions = [
  {
    value: 'prepaid',
    label: 'Prepaid',
  },
  {
    value: 'postpaid',
    label: 'Postpaid',
  },
]

export const CreateUser = [
  {label: 'Owner', detail: 'Best for business owners and company administrators', value: 'owner'},
]
export const whitelabelUser = [
  {
    label: 'Whitelabel User',
    detail: 'Best for business owners and company administrators',
    value: 'whitelabel user',
  },
]
export const SelectFeature = [
  'Campaign',
  'Automation',
  'Lead Generation',
  'Quick Message',
  'API',
  'Reviews',
  'Wallet Card'
]
